import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import UsersScoreboard from './UsersScoreboard';
import Loading from '../../../../components/Loading';

const queryUserElementScores = gql`
  query UsersScores($projectId: String) {
    usersScores(projectId: $projectId) {
      scores {
        id,
        element_id,
        score,
        data,
        responsibility,
      }
    }
  }
`;

const withData = compose(
  graphql(queryUserElementScores, {
    options: ({ project }) => ({
      variables: {
        projectId: project.get('id'),
      },
      fetchPolicy: 'cache-and-network',
    }),
  }),
);

@withData
export default class UsersScoreboardContainer extends Component {
  static propTypes = {};

  userLoadedCheck = () => {
    const { users, projectUsers } = this.props;

    return projectUsers.reduce((p, c) => {
      if (!p) return p;

      if (!users.has(c.get('id'))) return false;
      return true;
    }, true);
  }

  render() {
    const { data: { loading, usersScores }, users, scoreboard } = this.props;

    if (loading || !users || !users.size || !usersScores || !this.userLoadedCheck()) return <Loading loadingMessage="Loading users data..." />;
    else return <UsersScoreboard scores={usersScores.scores} users={users} scoreboard={scoreboard} />;
  }
}

UsersScoreboardContainer.propTypes = {
  data: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/UsersScoreboard/UsersScoreboardContainer.js